import {
  getOneXpExperiments,
  hasOneXpRequestFinished
} from 'src/universal/redux/oneXp';
import { getCardMemberCards, isGCSMember } from 'src/universal/redux/cardMemberInfo';
import { getPageFirstCardData } from 'src/universal/redux/page';
import { getExperimentalPageData } from 'src/universal/redux/page';
import { createSelector } from 'reselect';

export const isG175Variant = createSelector(
  [getOneXpExperiments],
  oneXpExperiments => {
    return (
      oneXpExperiments['GCS-175-PDP-CM-AddEmp-Banner']?.dimensions[0]?.variant ===
      'experiment'
    );
  }
);

export const getCombinedG175Data = createSelector(
  [
    isG175Variant,
    hasOneXpRequestFinished,
    getExperimentalPageData,
    getPageFirstCardData,
    isGCSMember,
    getCardMemberCards
  ],
  (
    g175Variant,
    oneXpDecided,
    { g175CmAddEmpBanner },
    currCard,
    isGcsCm,
    userCards
  ) => {
    let needToRenderG175 = false;
    if (g175Variant && oneXpDecided && isGcsCm) {
      const matchedCard = (userCards || []).find(
        card => card.shortName === currCard?.shortName
      );
      needToRenderG175 = !!matchedCard;
    }

    return {
      isG175Variant: g175Variant,
      needToRenderG175,
      staticData: g175CmAddEmpBanner,
      oneXpDecided
    };
  }
);
